import React, { FC, SetStateAction, useEffect, useState } from 'react';
import { useUncontrolledInput } from 'modules/core/hooks';
import { IOption } from 'modules/core/types';
import { LINE_DELIMITER } from 'modules/core/constants';
import { Option as IMultiselectOption } from 'react-multi-select-component/dist';

import { MultiSelectUI } from './styles';

interface ISimpleMultiSelect {
  options: IOption[];
  name: string;
  defaultValue?: any;
}

const filterOptions = (options: IMultiselectOption[], filter: string) => {
  if (!filter) return options;

  return options.filter(({ label }) => label?.toLowerCase().includes(filter.toLowerCase()));
};

export const SimpleMultiSelect: FC<ISimpleMultiSelect> = ({ options, name, defaultValue }) => {
  const prepareOptions = options.map((option) => ({ ...option, label: option.title }));
  const { setValue, fieldValue } = useUncontrolledInput(name);
  const [selected, setSelected] = useState([]);

  const onChange = (value: SetStateAction<never[]>) => {
    const convertedToStringValue = (value as IOption[]).map((item) => item.value).join(LINE_DELIMITER);

    setSelected(value);
    setValue(name, convertedToStringValue);
  };

  useEffect(() => {
    const currentValue = fieldValue || defaultValue || '';

    const convertedToArrayValue: any = (() =>
      prepareOptions.filter((option) => currentValue?.split(LINE_DELIMITER).includes(option.value)))();

    setSelected(convertedToArrayValue);
    setValue(name, currentValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldValue, defaultValue]);

  return (
    <MultiSelectUI
      options={prepareOptions}
      value={selected}
      filterOptions={filterOptions}
      onChange={(value: SetStateAction<never[]>) => onChange(value)}
      labelledBy="Select"
    />
  );
};
